import axios from '@/libs/api.request'

export const SaveProject = (data) => {
  return axios.request({
    url: '/company/project/save',
    data,
    method: 'post'
  })
}

export const GetProject = (data) => {
  return axios.request({
    url: '/company/project/list',
    params: data,
    method: 'get'
  })
}
export const GetProjectStaff = (data) => {
  return axios.request({
    url: '/company/project/GetProjectStaff',
    params: data,
    method: 'get'
  })
}
export const SaveProjectStaff = (data) => {
  return axios.request({
    url: '/company/project/SaveProjectStaff',
    data,
    method: 'post'
  })
}
export const DeleteProjectStaff = (data) => {
  return axios.request({
    url: '/company/project/DeleteProjectStaff',
    data,
    method: 'post'
  })
}

export const GetStaffProject = (data) => {
  return axios.request({
    url: '/company/project/GetStaffProject',
    params: data,
    method: 'get'
  })
}
export const SaveStaffUseProject = (data) => {
  return axios.request({
    url: '/company/project/SaveStaffUseProject',
    data,
    method: 'post'
  })
}
export const CloseStaffUseProject = (data) => {
  return axios.request({
    url: '/company/project/CloseStaffUseProject',
    data,
    method: 'post'
  })
}
